import React from "react";
import "../Pages/CSS/AboutUs.css";
import aboutImage1 from "../Components/Assets/Frontend_Assets/khancollections.jpg";
import aboutImage2 from "../Components/Assets/Frontend_Assets/HOK_Logo.webp";

const AboutUs = () => {
  return (
    <div className="about-us-container">
      <h1>About RunWear Shoes</h1>

      {/* INTRODUCTION */}
      <section className="about-section intro">
        <div className="text">
          <h2>Who We Are</h2>
          <p>
            RunWear Shoes is dedicated to providing premium quality fabrics
            and stylish clothing for men, women, and kids. Our collections
            are designed to combine tradition with modern trends to give our
            customers the best fashion experience.
          </p>
        </div>
        <img src={aboutImage1} alt="RunWear Shoes" />
      </section>

      {/* MISSION & VISION */}
      <section className="about-section mission">
        <img src={aboutImage2} alt="Mission & Vision" />
        <div className="text">
          <h2>Our Mission</h2>
          <p>
            To provide our customers with high-quality clothing that blends
            comfort, elegance, and tradition. We aim to make shopping an
            enjoyable experience for everyone.
          </p>
          <h2>Our Vision</h2>
          <p>
            To become the leading fashion brand in Pakistan, known for
            exceptional quality, unique designs, and excellent customer
            service.
          </p>
        </div>
      </section>

      {/* STORY / TEAM */}
      <section className="about-section story">
        <h2>Our Story</h2>
        <p>
          Founded in 2020, RunWear Shoes has grown rapidly with a focus on
          customer satisfaction. We work closely with our designers and
          craftsmen to deliver clothing that is both stylish and durable.
        </p>
      </section>
    </div>
  );
};

export default AboutUs;
